if (!window.melandiColorCardsInstalled) {
  window.melandiColorCardsInstalled = true;
  document.addEventListener('click', function(event) {
    const card = event.target.closest('.melandi-color-card');
    if (!card) return;
    const group = card.closest('[data-color-select]');
    const select = document.getElementById(group.dataset.colorSelect);
    if (!select || select.value === card.dataset.colorValue) return;
    select.value = card.dataset.colorValue;
    group.querySelectorAll('.melandi-color-card').forEach(button => button.setAttribute('aria-pressed', String(button === card)));
    select.dispatchEvent(new Event('change', {bubbles: true}));
  });
  document.addEventListener('change', function(event) {
    if (!(event.target instanceof HTMLSelectElement)) return;
    document.querySelectorAll('[data-color-select]').forEach(group => {
      if (group.dataset.colorSelect !== event.target.id) return;
      group.querySelectorAll('.melandi-color-card').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.colorValue === event.target.value)));
    });
  });
}
